import { render, staticRenderFns } from "./ExternalDamageLocalization.vue?vue&type=template&id=16a61a23&scoped=true"
import script from "./ExternalDamageLocalization.vue?vue&type=script&lang=ts"
export * from "./ExternalDamageLocalization.vue?vue&type=script&lang=ts"
import style0 from "./ExternalDamageLocalization.vue?vue&type=style&index=0&id=16a61a23&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a61a23",
  null
  
)

export default component.exports